
/**
   * PredictiveSearch
   * @description Uses the Shopify predictive search api for rendering search results.
   * @link https://shopify.dev/api/ajax/reference/predictive-search
   */
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('[data-predicative-search="input"]');
    this.reset = this.querySelector('[data-predicative-search="reset"]');
    this.submit = this.querySelector('button[type="submit"]');

    this.predictiveSearchResults = document.querySelector('[data-predicative-search="results"]');
    this.predictiveSearchResources = this.predictiveSearchResults.getAttribute('data-resources-types') || 'product';
    this.predictiveSearchMaxSize = this.predictiveSearchResults.getAttribute('data-max-results') || 4;

    this.listeners = {
      inputChange: debounce(event => {
        this.onChange(event);
      }, 100),
      resetClick: () => {
        this.clearInput();
        this.handleInputState();
      },
      inputKeyup: () => {
        this.handleInputState();
      },
    };

    this.handleInputState();

    this.input.addEventListener('focus', () => window.dispatchEvent(new Event('window:search-performed')));
    this.input.addEventListener('input', this.listeners.inputChange);
    this.reset.addEventListener('click', this.listeners.resetClick);
    this.input.addEventListener('keyup', this.listeners.inputKeyup);
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const url = `${routes.predictive_search_url}?q=${searchTerm}&resources[type]=${this.predictiveSearchResources}&resources[limit]=${this.predictiveSearchMaxSize}&section_id=theme-predictive-search`;
    console.log(url);
    fetch(url)
      .then(response => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then(text => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-theme-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch(error => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    trapFocus(this);
    document.body.classList.add('search-is-open');
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    removeTrapFocus();
    document.body.classList.remove('search-is-open');
  }

  handleInputState() {
    const state = this.input.value.length > 0;
    if (state) {
      this.reset.classList.remove('hidden');
    }
    else {
      this.reset.classList.add('hidden');
      this.close();
    }
    return state;
  }

  clearInput() {
    this.input.value = '';
    this.input.focus();
    this.submit.disabled = 'disabled';
  }
}
if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
